var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"text-gray-600 text-base flex items-center border-b"},_vm._l((_vm.menuItemsByRole),function(item,index){return _c('router-link',{key:`user-menu-item-${index}`,staticClass:"text-center w-32",class:{
      'text-atlas-blue font-semibold border-b-2 border-atlas-blue':
        _vm.currentPage === item.path,
      'mr-4': _vm.menuItemsByRole.length !== index
    },attrs:{"to":item.path}},[_vm._v(_vm._s(item.text))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }